import { render, staticRenderFns } from "./ApplicantInfoForm.vue?vue&type=template&id=68f0206f&scoped=true&"
import script from "./ApplicantInfoForm.vue?vue&type=script&lang=js&"
export * from "./ApplicantInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantInfoForm.vue?vue&type=style&index=0&id=68f0206f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f0206f",
  null
  
)

component.options.__file = "ApplicantInfoForm.vue"
export default component.exports